// extracted by mini-css-extract-plugin
module.exports = {"animate":"List_animate__2KpYb"};